import { Module } from "../lib/modules";
import { StateManager } from "../lib/stateManager";

interface LoginState {
  loading: boolean;
  error: string | null;
  requiresTOTP: boolean;
}

export const Login: Module<LoginState> = () => {
  // Create a state manager with initial state
  const state = new StateManager<LoginState>({
    loading: false,
    error: null,
    requiresTOTP: false
  });

  const handleSubmit = async (username: string, password: string, rememberMe: boolean, totpCode?: string) => {
    state.set("loading", true);
    state.set("error", null);

    try {
      const payload: any = { username, password, remember_me: rememberMe };
      if (totpCode) {
        payload.totp_code = totpCode;
      }

      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
        credentials: "include"
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.requires_totp) {
          state.set("requiresTOTP", true);
          state.set("error", data.message || "TOTP code required");
          return false;
        }
        state.set("error", data.message || "Login failed");
        return false;
      }

      if ("success" in data) {
        if (data.success) {
          window.location.href = data.redirect || "/admin";
          return true;
        } else {
          if (data.requires_totp) {
            state.set("requiresTOTP", true);
            state.set("error", data.message || "TOTP code required");
            return false;
          }
          state.set("error", data.message || "Login failed");
          return false;
        }
      }
    } catch (err) {
      state.set("error", "An error occurred during login");
      state.set("loading", false);
      return false;
    } finally {
      state.set("loading", false);
    }
  };

  const init = () => {
    const usernameField = document.getElementById("username") as HTMLInputElement;
    const passwordField = document.getElementById("password") as HTMLInputElement;
    const rememberMeField = document.getElementById("remember") as HTMLInputElement;
    const totpCodeField = document.getElementById("totp-code") as HTMLInputElement;
    const form = document.querySelector(".login__form") as HTMLFormElement;

    if (!usernameField || !passwordField || !form) {
      console.error("Login form elements not found");
      return;
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const username = usernameField.value;
      const password = passwordField.value;
      const rememberMe = rememberMeField.checked;
      const totpCode = totpCodeField?.value || undefined;
      handleSubmit(username, password, rememberMe, totpCode);
    });
  };

  state.onChange("error", (error) => {
    console.log("Error state changed:", error);
    const errorMessageContainer = document.querySelector(".login__error-message") as HTMLDivElement;
    if (errorMessageContainer) {
      errorMessageContainer.textContent = error || "";
      errorMessageContainer.style.display = error ? "block" : "none";
    } else {
      console.error("Error message container not found");
    }
  });

  state.onChange("requiresTOTP", (requiresTOTP) => {
    console.log("TOTP requirement changed:", requiresTOTP);
    const totpGroup = document.getElementById("totp-group") as HTMLDivElement;
    if (totpGroup) {
      totpGroup.style.display = requiresTOTP ? "block" : "none";
      if (requiresTOTP) {
        const totpCodeField = document.getElementById("totp-code") as HTMLInputElement;
        if (totpCodeField) {
          totpCodeField.focus();
        }
      }
    }
  });

  const destroy = () => {};

  return {
    init,
    destroy,
    state,
    pages: ["/login"],
    name: "login"
  };
};
